import { IUpdateInformacaoFaturamentoUseCase } from "../../../presentation/useCases/update/update_informacao_faturamento_use_case";
import { InformacaoFaturamento } from "../../models/informacao_faturamento";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateinformacaoFaturamentoUseCase
 */

export class UpdateInformacaoFaturamentoUseCase implements IUpdateInformacaoFaturamentoUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async updateInformacaoFaturamento(form: InformacaoFaturamento): Promise<InformacaoFaturamento> {
    const result = await this.repository.updateInformacaoFaturamento(form)
    return result;
  }
}
